import { Button, Pagination } from 'react-bootstrap';

interface IProps {
  pages: number;
  activePage: number;
  setActivePage: React.Dispatch<React.SetStateAction<number>>;
  disabled?: boolean;
}

const PaginationComponent = ({ activePage, pages, setActivePage, disabled = false }: IProps) => {
  const items: any[] = [];

  const getMin = () => {
    if (pages < 3) return 1;
    if (activePage === pages) return activePage - 2;
    if (activePage === 1) return activePage;
    else return activePage - 1;
  };

  const getMax = () => {
    if (pages < 3) return pages;
    if (activePage === 1) return activePage + 2;
    if (activePage === pages) return activePage;
    else return activePage + 1;
  };

  const getItems = () => {
    items.push(
      <Pagination.Item
        key={'first'}
        disabled={activePage === 1 || disabled}
        active={false}
        className="paginationButton align-items-center"
        onClick={() => setActivePage(1)}
      >
        {'<<'}
      </Pagination.Item>
    );

    for (let number = getMin(); number <= getMax(); number++) {
      items.push(
        <Pagination.Item
          key={number}
          active={number === activePage}
          className="paginationButton align-items-center"
          onClick={() => setActivePage(number)}
          disabled={disabled}
        >
          {number}
        </Pagination.Item>
      );
    }

    items.push(
      <Pagination.Item
        key={'last'}
        disabled={activePage === pages || disabled}
        active={false}
        className="paginationButton align-items-center"
        onClick={() => setActivePage(pages)}
      >
        {'>>'}
      </Pagination.Item>
    );

    return items;
  };

  return (
    <>
      <div className="d-flex flex-row justify-content-between align-items-center gap-2">
        <Button
          disabled={activePage === 1}
          className="dataGridNavigationButton"
          size="sm"
          onClick={() => setActivePage(activePage - 1)}
        >
          <i className="bi bi-chevron-left"></i>
          <span className=" d-none d-sm-inline">Page précédente</span>
        </Button>
        <Pagination className="d-flex mb-0 gap-2">
          {getItems()}
        </Pagination>
        <Button
          disabled={activePage === pages}
          className="dataGridNavigationButton"
          size="sm"
          onClick={() => setActivePage(activePage + 1)}
        >
          <span className="d-none d-sm-inline">Page suivante</span>
          <i className="bi bi-chevron-right"></i>
        </Button>
      </div>
    </>
  );
};
export default PaginationComponent;
